var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "customerInvoiceDetail" }, [
    _c(
      "div",
      {
        staticStyle: {
          padding: "0 10px",
          height: "calc(100vh - 140px)",
          "overflow-y": "auto",
        },
      },
      [
        _c(
          "el-form",
          {
            ref: "formDataRef",
            attrs: {
              "label-position": "top",
              size: "small",
              model: _vm.formData,
            },
          },
          [
            _c(
              "el-row",
              { attrs: { gutter: 10 } },
              [
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          label: _vm.$t("orderCenterCont.customer"),
                          prop: "customerId",
                          rules: [
                            {
                              required: true,
                              message: _vm.$t("collectionCenter.notNull"),
                              trigger: "change",
                            },
                          ],
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "operationCenter.PleaseSelect"
                              ),
                              clearable: "",
                              filterable: "",
                              remote: "",
                              "reserve-keyword": "",
                              "remote-method": _vm.getUserOption,
                            },
                            on: {
                              "visible-change": _vm.changeUserOption,
                              change: _vm.customerChange,
                            },
                            model: {
                              value: _vm.formData.customerId,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "customerId", $$v)
                              },
                              expression: "formData.customerId",
                            },
                          },
                          _vm._l(_vm.customerList, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: item.username + "（" + item.id + "）",
                                value: item.id,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { attrs: { span: 8 } },
                  [
                    _c(
                      "el-form-item",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          label: _vm.$t("collectionCenter.businessT"),
                          prop: "businessType",
                          rules: [
                            {
                              required: true,
                              message: _vm.$t("collectionCenter.notNull"),
                              trigger: "change",
                            },
                          ],
                        },
                      },
                      [
                        _c(
                          "el-select",
                          {
                            staticStyle: { width: "100%" },
                            attrs: {
                              placeholder: _vm.$t(
                                "operationCenter.PleaseSelect"
                              ),
                              clearable: "",
                              filterable: "",
                            },
                            model: {
                              value: _vm.formData.businessType,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "businessType", $$v)
                              },
                              expression: "formData.businessType",
                            },
                          },
                          [
                            _c("el-option", {
                              key: "0",
                              attrs: {
                                label: _vm.$t(
                                  "collectionCenter.expressDelivery"
                                ),
                                value: 0,
                              },
                            }),
                            _c("el-option", {
                              key: "1",
                              attrs: {
                                label: _vm.$t("collectionCenter.lanshou"),
                                value: 1,
                              },
                            }),
                            _c("el-option", {
                              key: "2",
                              attrs: {
                                label: _vm.$t("basicData.StockingAndPickup"),
                                value: 2,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-collapse",
              {
                attrs: { accordion: "" },
                on: { change: _vm.handleChange },
                model: {
                  value: _vm.activeName,
                  callback: function ($$v) {
                    _vm.activeName = $$v
                  },
                  expression: "activeName",
                },
              },
              _vm._l(_vm.formElement.elementForm, function (item, key) {
                return _c(
                  "el-collapse-item",
                  { key: key, attrs: { name: key } },
                  [
                    _c(
                      "template",
                      { slot: "title" },
                      [
                        item.length > 0
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "16px",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(item[0].titleOption[_vm.$i18n.locale])
                                ),
                              ]
                            )
                          : _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "16px",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.formElementFixed[key][0].titleOption[
                                      _vm.$i18n.locale
                                    ]
                                  )
                                ),
                              ]
                            ),
                        _vm.formElementFixed[key][0].tip
                          ? _c(
                              "el-tooltip",
                              {
                                staticClass: "item",
                                attrs: { effect: "dark", placement: "top" },
                              },
                              [
                                _c("template", { slot: "content" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.formElementFixed[key][0].tip[
                                        _vm.$i18n.locale
                                      ]
                                    )
                                  ),
                                ]),
                                _c(
                                  "span",
                                  { staticStyle: { "margin-left": "5px" } },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-warning",
                                      staticStyle: { "font-size": "18px" },
                                    }),
                                  ]
                                ),
                              ],
                              2
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    item.length > 0
                      ? _c(
                          "div",
                          _vm._l(
                            _vm.formElement.elementForm[key],
                            function (item1, index) {
                              return _c(
                                "div",
                                { key: index },
                                [
                                  _c(
                                    "el-card",
                                    {
                                      staticStyle: { "margin-bottom": "10px" },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-size": "16px",
                                            "font-weight": "bold",
                                            "margin-bottom": "10px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item1.titleOption[
                                                  _vm.$i18n.locale
                                                ] +
                                                  (index + 1)
                                              ) +
                                              " "
                                          ),
                                          _vm.viewType !== 1
                                            ? _c(
                                                "el-button",
                                                {
                                                  staticStyle: {
                                                    float: "right",
                                                  },
                                                  attrs: {
                                                    size: "small",
                                                    type: "danger",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeForm(
                                                        key,
                                                        index
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "collectionCenter.Delete"
                                                      )
                                                    )
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-row",
                                        { attrs: { gutter: 10 } },
                                        _vm._l(item1.column, function (field) {
                                          return _c(
                                            "el-col",
                                            {
                                              key: field.field,
                                              attrs: { span: 8 },
                                            },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label:
                                                      field.titleOption[
                                                        _vm.$i18n.locale
                                                      ],
                                                    prop:
                                                      "form." +
                                                      key +
                                                      "." +
                                                      index +
                                                      "." +
                                                      field.field,
                                                    rules:
                                                      _vm.getValidationRules(
                                                        field,
                                                        key,
                                                        index
                                                      ),
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "template",
                                                    { slot: "label" },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            field.titleOption[
                                                              _vm.$i18n.locale
                                                            ]
                                                          ) +
                                                          " "
                                                      ),
                                                      field.tip
                                                        ? _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "dark",
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "template",
                                                                {
                                                                  slot: "content",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      field.tip[
                                                                        _vm
                                                                          .$i18n
                                                                          .locale
                                                                      ]
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    "margin-left":
                                                                      "5px",
                                                                  },
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "el-icon-warning",
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "18px",
                                                                      },
                                                                  }),
                                                                ]
                                                              ),
                                                            ],
                                                            2
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                  field.type === "input"
                                                    ? _c("el-input", {
                                                        style: {
                                                          width:
                                                            field.field ===
                                                              "cep" ||
                                                            field.field ===
                                                              "cnpj"
                                                              ? "calc(100% - 35px)"
                                                              : "100%",
                                                        },
                                                        attrs: {
                                                          value:
                                                            _vm.getFieldValue(
                                                              key,
                                                              index,
                                                              field.field
                                                            ),
                                                          placeholder: _vm.$t(
                                                            "collectionCenter.pleaseInput"
                                                          ),
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            return _vm.updateFieldValue(
                                                              key,
                                                              index,
                                                              field.field,
                                                              $event
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : field.type === "textarea"
                                                    ? _c("el-input", {
                                                        staticStyle: {
                                                          width: "100%",
                                                        },
                                                        attrs: {
                                                          type: "textarea",
                                                          rows: 3,
                                                          value:
                                                            _vm.getFieldValue(
                                                              key,
                                                              index,
                                                              field.field
                                                            ),
                                                          placeholder: _vm.$t(
                                                            "collectionCenter.pleaseInput"
                                                          ),
                                                        },
                                                        on: {
                                                          input: function (
                                                            $event
                                                          ) {
                                                            return _vm.updateFieldValue(
                                                              key,
                                                              index,
                                                              field.field,
                                                              $event
                                                            )
                                                          },
                                                        },
                                                      })
                                                    : field.type === "select"
                                                    ? _c(
                                                        "el-select",
                                                        {
                                                          staticStyle: {
                                                            width: "100%",
                                                          },
                                                          attrs: {
                                                            value:
                                                              _vm.getFieldValue(
                                                                key,
                                                                index,
                                                                field.field
                                                              ),
                                                            placeholder: _vm.$t(
                                                              "collectionCenter.pleaseChoose"
                                                            ),
                                                            clearable: "",
                                                            multiple:
                                                              field.multiple,
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              return _vm.updateFieldValue(
                                                                key,
                                                                index,
                                                                field.field,
                                                                $event
                                                              )
                                                            },
                                                          },
                                                        },
                                                        _vm._l(
                                                          field.options,
                                                          function (option) {
                                                            return _c(
                                                              "el-option",
                                                              {
                                                                key: option.value,
                                                                attrs: {
                                                                  label:
                                                                    option.label,
                                                                  value:
                                                                    option.value,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      )
                                                    : field.type === "radio"
                                                    ? _c(
                                                        "el-radio-group",
                                                        {
                                                          attrs: {
                                                            value:
                                                              _vm.getFieldValue(
                                                                key,
                                                                index,
                                                                field.field
                                                              ),
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              return _vm.updateFieldValue(
                                                                key,
                                                                index,
                                                                field.field,
                                                                $event
                                                              )
                                                            },
                                                          },
                                                        },
                                                        _vm._l(
                                                          field.options,
                                                          function (option) {
                                                            return _c(
                                                              "el-radio",
                                                              {
                                                                key: option.value,
                                                                attrs: {
                                                                  label:
                                                                    option.value,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      option.label
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      )
                                                    : field.type === "checkbox"
                                                    ? _c(
                                                        "el-checkbox-group",
                                                        {
                                                          attrs: {
                                                            value:
                                                              _vm.getFieldValue(
                                                                key,
                                                                index,
                                                                field.field
                                                              ),
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              return _vm.updateFieldValue(
                                                                key,
                                                                index,
                                                                field.field,
                                                                $event
                                                              )
                                                            },
                                                          },
                                                        },
                                                        _vm._l(
                                                          field.options,
                                                          function (option) {
                                                            return _c(
                                                              "el-checkbox",
                                                              {
                                                                key: option.value,
                                                                attrs: {
                                                                  label:
                                                                    option.value,
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      option.label
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  field.field === "cep"
                                                    ? _c(
                                                        "el-popover",
                                                        {
                                                          attrs: {
                                                            placement:
                                                              "top-end",
                                                            width: "260",
                                                            trigger: "manual",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.visibleCep[
                                                                key + index
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.visibleCep,
                                                                key + index,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "visibleCep[key + index]",
                                                          },
                                                        },
                                                        [
                                                          _c("div", [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "text-align":
                                                                    "right",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-button",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        padding:
                                                                          "0",
                                                                      },
                                                                    attrs: {
                                                                      type: "text",
                                                                      size: "mini",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          _vm.visibleCep[
                                                                            key +
                                                                              index
                                                                          ] = false
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("i", {
                                                                      staticClass:
                                                                        "el-icon-close",
                                                                      staticStyle:
                                                                        {
                                                                          "font-size":
                                                                            "18px",
                                                                        },
                                                                    }),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "div",
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "mdfeTranslate.IBGECode"
                                                                      )
                                                                    ) +
                                                                    "： "
                                                                ),
                                                                _vm.addressData[
                                                                  key + index
                                                                ]
                                                                  ? _c(
                                                                      "el-tooltip",
                                                                      {
                                                                        staticClass:
                                                                          "item",
                                                                        attrs: {
                                                                          effect:
                                                                            "light",
                                                                          placement:
                                                                            "right",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "template",
                                                                          {
                                                                            slot: "content",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "el-button",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        type: "text",
                                                                                        size: "mini",
                                                                                      },
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.copy(
                                                                                            _vm
                                                                                              .addressData[
                                                                                              key +
                                                                                                index
                                                                                            ]
                                                                                              .cityCode
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "orderDetails.copy"
                                                                                        )
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .addressData[
                                                                                  key +
                                                                                    index
                                                                                ]
                                                                                  .cityCode
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      2
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "div",
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "collectionCenter.city"
                                                                      )
                                                                    ) +
                                                                    "： "
                                                                ),
                                                                _vm.addressData[
                                                                  key + index
                                                                ]
                                                                  ? _c(
                                                                      "el-tooltip",
                                                                      {
                                                                        staticClass:
                                                                          "item",
                                                                        attrs: {
                                                                          effect:
                                                                            "light",
                                                                          placement:
                                                                            "right",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "template",
                                                                          {
                                                                            slot: "content",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "el-button",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        type: "text",
                                                                                        size: "mini",
                                                                                      },
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.copy(
                                                                                            _vm
                                                                                              .addressData[
                                                                                              key +
                                                                                                index
                                                                                            ]
                                                                                              .city
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "orderDetails.copy"
                                                                                        )
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .addressData[
                                                                                  key +
                                                                                    index
                                                                                ]
                                                                                  .city
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      2
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "div",
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "collectionCenter.state"
                                                                      )
                                                                    ) +
                                                                    "： "
                                                                ),
                                                                _vm.addressData[
                                                                  key + index
                                                                ]
                                                                  ? _c(
                                                                      "el-tooltip",
                                                                      {
                                                                        staticClass:
                                                                          "item",
                                                                        attrs: {
                                                                          effect:
                                                                            "light",
                                                                          placement:
                                                                            "right",
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "template",
                                                                          {
                                                                            slot: "content",
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "el-button",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        type: "text",
                                                                                        size: "mini",
                                                                                      },
                                                                                    on: {
                                                                                      click:
                                                                                        function (
                                                                                          $event
                                                                                        ) {
                                                                                          return _vm.copy(
                                                                                            _vm
                                                                                              .addressData[
                                                                                              key +
                                                                                                index
                                                                                            ]
                                                                                              .uf
                                                                                          )
                                                                                        },
                                                                                    },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      _vm._s(
                                                                                        _vm.$t(
                                                                                          "orderDetails.copy"
                                                                                        )
                                                                                      )
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ],
                                                                              1
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _c(
                                                                          "span",
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                _vm
                                                                                  .addressData[
                                                                                  key +
                                                                                    index
                                                                                ]
                                                                                  .uf
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ],
                                                                      2
                                                                    )
                                                                  : _vm._e(),
                                                              ],
                                                              1
                                                            ),
                                                          ]),
                                                          _c(
                                                            "el-button",
                                                            {
                                                              staticStyle: {
                                                                padding:
                                                                  "4px 5px",
                                                                float: "right",
                                                              },
                                                              attrs: {
                                                                slot: "reference",
                                                                type: "primary",
                                                                plain: "",
                                                                disabled:
                                                                  _vm.viewType ===
                                                                  1,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.showCepInfo(
                                                                      key,
                                                                      index,
                                                                      field.field
                                                                    )
                                                                  },
                                                              },
                                                              slot: "reference",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-search",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "22px",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  field.field === "cnpj"
                                                    ? _c(
                                                        "el-popover",
                                                        {
                                                          attrs: {
                                                            placement: "top",
                                                            width: "300",
                                                            trigger: "manual",
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.visibleCnpj[
                                                                key + index
                                                              ],
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.visibleCnpj,
                                                                key + index,
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "visibleCnpj[key + index]",
                                                          },
                                                        },
                                                        [
                                                          _vm.cnpjData[
                                                            key + index
                                                          ]
                                                            ? _c(
                                                                "div",
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "text-align":
                                                                            "right",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "el-button",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              padding:
                                                                                "0",
                                                                            },
                                                                          attrs:
                                                                            {
                                                                              type: "text",
                                                                              size: "mini",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                _vm.visibleCnpj[
                                                                                  key +
                                                                                    index
                                                                                ] = false
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "i",
                                                                            {
                                                                              staticClass:
                                                                                "el-icon-close",
                                                                              staticStyle:
                                                                                {
                                                                                  "font-size":
                                                                                    "18px",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "el-form",
                                                                    {
                                                                      ref:
                                                                        key +
                                                                        index +
                                                                        "Ref",
                                                                      refInFor: true,
                                                                      attrs: {
                                                                        model:
                                                                          _vm.cnpjData,
                                                                        "label-position":
                                                                          "top",
                                                                        size: "small",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "el-form-item",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              label:
                                                                                "cnpj",
                                                                              prop:
                                                                                key +
                                                                                index +
                                                                                ".cnpj",
                                                                              rules:
                                                                                [
                                                                                  {
                                                                                    required: true,
                                                                                    message:
                                                                                      _vm.$t(
                                                                                        "collectionCenter.pleaseInput"
                                                                                      ),
                                                                                    trigger:
                                                                                      [
                                                                                        "blur",
                                                                                        "change",
                                                                                      ],
                                                                                  },
                                                                                ],
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "el-input",
                                                                            {
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    _vm
                                                                                      .cnpjData[
                                                                                      key +
                                                                                        index
                                                                                    ]
                                                                                      .cnpj,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        _vm
                                                                                          .cnpjData[
                                                                                          key +
                                                                                            index
                                                                                        ],
                                                                                        "cnpj",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "cnpjData[key + index].cnpj",
                                                                                },
                                                                            }
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                      _c(
                                                                        "el-form-item",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              label:
                                                                                _vm.$t(
                                                                                  "mdfeTranslate.StateAbbreviationUF"
                                                                                ),
                                                                              prop:
                                                                                key +
                                                                                index +
                                                                                ".state",
                                                                              rules:
                                                                                [
                                                                                  {
                                                                                    required: true,
                                                                                    message:
                                                                                      _vm.$t(
                                                                                        "collectionCenter.pleaseChoose"
                                                                                      ),
                                                                                    trigger:
                                                                                      [
                                                                                        "blur",
                                                                                        "change",
                                                                                      ],
                                                                                  },
                                                                                ],
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "el-select",
                                                                            {
                                                                              staticStyle:
                                                                                {
                                                                                  width:
                                                                                    "100%",
                                                                                },
                                                                              attrs:
                                                                                {
                                                                                  placeholder:
                                                                                    _vm.$t(
                                                                                      "placeOrder.pleaseChoose"
                                                                                    ),
                                                                                  clearable:
                                                                                    "",
                                                                                  filterable:
                                                                                    "",
                                                                                },
                                                                              model:
                                                                                {
                                                                                  value:
                                                                                    _vm
                                                                                      .cnpjData[
                                                                                      key +
                                                                                        index
                                                                                    ]
                                                                                      .state,
                                                                                  callback:
                                                                                    function (
                                                                                      $$v
                                                                                    ) {
                                                                                      _vm.$set(
                                                                                        _vm
                                                                                          .cnpjData[
                                                                                          key +
                                                                                            index
                                                                                        ],
                                                                                        "state",
                                                                                        $$v
                                                                                      )
                                                                                    },
                                                                                  expression:
                                                                                    "cnpjData[key + index].state",
                                                                                },
                                                                            },
                                                                            _vm._l(
                                                                              _vm.senderStateList,
                                                                              function (
                                                                                item
                                                                              ) {
                                                                                return _c(
                                                                                  "el-option",
                                                                                  {
                                                                                    key: item.id,
                                                                                    attrs:
                                                                                      {
                                                                                        label:
                                                                                          item.shortName,
                                                                                        value:
                                                                                          item.shortName,
                                                                                      },
                                                                                  }
                                                                                )
                                                                              }
                                                                            ),
                                                                            1
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "margin-bottom":
                                                                            "10px",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "el-button",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              type: "primary",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.getCnpjInfo(
                                                                                  key,
                                                                                  index,
                                                                                  field.field
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "collectionCenter.search"
                                                                              )
                                                                            )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                  _c("div", [
                                                                    _c(
                                                                      "div",
                                                                      [
                                                                        _vm._v(
                                                                          " cnpj： "
                                                                        ),
                                                                        _c(
                                                                          "el-tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "item",
                                                                            attrs:
                                                                              {
                                                                                effect:
                                                                                  "light",
                                                                                placement:
                                                                                  "right",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot: "content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "el-button",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            type: "text",
                                                                                            size: "mini",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.copy(
                                                                                                _vm
                                                                                                  .cnpjData[
                                                                                                  key +
                                                                                                    index
                                                                                                ]
                                                                                                  .cnpj
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "orderDetails.copy"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .cnpjData[
                                                                                      key +
                                                                                        index
                                                                                    ]
                                                                                      .cnpj
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "customerManagements.CompanyName"
                                                                              )
                                                                            ) +
                                                                            "： "
                                                                        ),
                                                                        _c(
                                                                          "el-tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "item",
                                                                            attrs:
                                                                              {
                                                                                effect:
                                                                                  "light",
                                                                                placement:
                                                                                  "right",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot: "content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "el-button",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            type: "text",
                                                                                            size: "mini",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.copy(
                                                                                                _vm
                                                                                                  .cnpjData[
                                                                                                  key +
                                                                                                    index
                                                                                                ]
                                                                                                  .name
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "orderDetails.copy"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .cnpjData[
                                                                                      key +
                                                                                        index
                                                                                    ]
                                                                                      .name
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "mdfeTranslate.CompanyAbbreviation"
                                                                              )
                                                                            ) +
                                                                            "： "
                                                                        ),
                                                                        _c(
                                                                          "el-tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "item",
                                                                            attrs:
                                                                              {
                                                                                effect:
                                                                                  "light",
                                                                                placement:
                                                                                  "right",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot: "content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "el-button",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            type: "text",
                                                                                            size: "mini",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.copy(
                                                                                                _vm
                                                                                                  .cnpjData[
                                                                                                  key +
                                                                                                    index
                                                                                                ]
                                                                                                  .abbreviation
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "orderDetails.copy"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .cnpjData[
                                                                                      key +
                                                                                        index
                                                                                    ]
                                                                                      .abbreviation
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      [
                                                                        _vm._v(
                                                                          " ie： "
                                                                        ),
                                                                        _c(
                                                                          "el-tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "item",
                                                                            attrs:
                                                                              {
                                                                                effect:
                                                                                  "light",
                                                                                placement:
                                                                                  "right",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot: "content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "el-button",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            type: "text",
                                                                                            size: "mini",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.copy(
                                                                                                _vm
                                                                                                  .cnpjData[
                                                                                                  key +
                                                                                                    index
                                                                                                ]
                                                                                                  .ieNumber
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "orderDetails.copy"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .cnpjData[
                                                                                      key +
                                                                                        index
                                                                                    ]
                                                                                      .ieNumber
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "collectionCenter.phone"
                                                                              )
                                                                            ) +
                                                                            " "
                                                                        ),
                                                                        _c(
                                                                          "el-tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "item",
                                                                            attrs:
                                                                              {
                                                                                effect:
                                                                                  "light",
                                                                                placement:
                                                                                  "right",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot: "content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "el-button",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            type: "text",
                                                                                            size: "mini",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.copy(
                                                                                                _vm
                                                                                                  .cnpjData[
                                                                                                  key +
                                                                                                    index
                                                                                                ]
                                                                                                  .phone
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "orderDetails.copy"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .cnpjData[
                                                                                      key +
                                                                                        index
                                                                                    ]
                                                                                      .phone
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "collectionCenter.Zip"
                                                                              )
                                                                            ) +
                                                                            "： "
                                                                        ),
                                                                        _c(
                                                                          "el-tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "item",
                                                                            attrs:
                                                                              {
                                                                                effect:
                                                                                  "light",
                                                                                placement:
                                                                                  "right",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot: "content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "el-button",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            type: "text",
                                                                                            size: "mini",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.copy(
                                                                                                _vm
                                                                                                  .cnpjData[
                                                                                                  key +
                                                                                                    index
                                                                                                ]
                                                                                                  .cep
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "orderDetails.copy"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .cnpjData[
                                                                                      key +
                                                                                        index
                                                                                    ]
                                                                                      .cep
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "collectionCenter.Area"
                                                                              )
                                                                            ) +
                                                                            "： "
                                                                        ),
                                                                        _c(
                                                                          "el-tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "item",
                                                                            attrs:
                                                                              {
                                                                                effect:
                                                                                  "light",
                                                                                placement:
                                                                                  "right",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot: "content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "el-button",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            type: "text",
                                                                                            size: "mini",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.copy(
                                                                                                _vm
                                                                                                  .cnpjData[
                                                                                                  key +
                                                                                                    index
                                                                                                ]
                                                                                                  .area
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "orderDetails.copy"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .cnpjData[
                                                                                      key +
                                                                                        index
                                                                                    ]
                                                                                      .area
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "mdfeTranslate.State"
                                                                              )
                                                                            ) +
                                                                            "： "
                                                                        ),
                                                                        _c(
                                                                          "el-tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "item",
                                                                            attrs:
                                                                              {
                                                                                effect:
                                                                                  "light",
                                                                                placement:
                                                                                  "right",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot: "content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "el-button",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            type: "text",
                                                                                            size: "mini",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.copy(
                                                                                                _vm
                                                                                                  .cnpjData[
                                                                                                  key +
                                                                                                    index
                                                                                                ]
                                                                                                  .state
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "orderDetails.copy"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .cnpjData[
                                                                                      key +
                                                                                        index
                                                                                    ]
                                                                                      .state
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "collectionCenter.city"
                                                                              )
                                                                            ) +
                                                                            "： "
                                                                        ),
                                                                        _c(
                                                                          "el-tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "item",
                                                                            attrs:
                                                                              {
                                                                                effect:
                                                                                  "light",
                                                                                placement:
                                                                                  "right",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot: "content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "el-button",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            type: "text",
                                                                                            size: "mini",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.copy(
                                                                                                _vm
                                                                                                  .cnpjData[
                                                                                                  key +
                                                                                                    index
                                                                                                ]
                                                                                                  .city
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "orderDetails.copy"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .cnpjData[
                                                                                      key +
                                                                                        index
                                                                                    ]
                                                                                      .city
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "mdfeTranslate.cityCode"
                                                                              )
                                                                            ) +
                                                                            "： "
                                                                        ),
                                                                        _c(
                                                                          "el-tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "item",
                                                                            attrs:
                                                                              {
                                                                                effect:
                                                                                  "light",
                                                                                placement:
                                                                                  "right",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot: "content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "el-button",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            type: "text",
                                                                                            size: "mini",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.copy(
                                                                                                _vm
                                                                                                  .cnpjData[
                                                                                                  key +
                                                                                                    index
                                                                                                ]
                                                                                                  .cityCode
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "orderDetails.copy"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .cnpjData[
                                                                                      key +
                                                                                        index
                                                                                    ]
                                                                                      .cityCode
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "collectionCenter.RecipientStreet"
                                                                              )
                                                                            ) +
                                                                            "： "
                                                                        ),
                                                                        _c(
                                                                          "el-tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "item",
                                                                            attrs:
                                                                              {
                                                                                effect:
                                                                                  "light",
                                                                                placement:
                                                                                  "right",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot: "content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "el-button",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            type: "text",
                                                                                            size: "mini",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.copy(
                                                                                                _vm
                                                                                                  .cnpjData[
                                                                                                  key +
                                                                                                    index
                                                                                                ]
                                                                                                  .street
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "orderDetails.copy"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .cnpjData[
                                                                                      key +
                                                                                        index
                                                                                    ]
                                                                                      .street
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "orderCenterCont.HouseNumber"
                                                                              )
                                                                            ) +
                                                                            "： "
                                                                        ),
                                                                        _c(
                                                                          "el-tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "item",
                                                                            attrs:
                                                                              {
                                                                                effect:
                                                                                  "light",
                                                                                placement:
                                                                                  "right",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot: "content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "el-button",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            type: "text",
                                                                                            size: "mini",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.copy(
                                                                                                _vm
                                                                                                  .cnpjData[
                                                                                                  key +
                                                                                                    index
                                                                                                ]
                                                                                                  .houseNumber
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "orderDetails.copy"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .cnpjData[
                                                                                      key +
                                                                                        index
                                                                                    ]
                                                                                      .houseNumber
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      [
                                                                        _vm._v(
                                                                          " " +
                                                                            _vm._s(
                                                                              _vm.$t(
                                                                                "mdfeTranslate.SupplementalAddress"
                                                                              )
                                                                            ) +
                                                                            "： "
                                                                        ),
                                                                        _c(
                                                                          "el-tooltip",
                                                                          {
                                                                            staticClass:
                                                                              "item",
                                                                            attrs:
                                                                              {
                                                                                effect:
                                                                                  "light",
                                                                                placement:
                                                                                  "right",
                                                                              },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "template",
                                                                              {
                                                                                slot: "content",
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _c(
                                                                                      "el-button",
                                                                                      {
                                                                                        attrs:
                                                                                          {
                                                                                            type: "text",
                                                                                            size: "mini",
                                                                                          },
                                                                                        on: {
                                                                                          click:
                                                                                            function (
                                                                                              $event
                                                                                            ) {
                                                                                              return _vm.copy(
                                                                                                _vm
                                                                                                  .cnpjData[
                                                                                                  key +
                                                                                                    index
                                                                                                ]
                                                                                                  .complement
                                                                                              )
                                                                                            },
                                                                                        },
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          _vm._s(
                                                                                            _vm.$t(
                                                                                              "orderDetails.copy"
                                                                                            )
                                                                                          )
                                                                                        ),
                                                                                      ]
                                                                                    ),
                                                                                  ],
                                                                                  1
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    _vm
                                                                                      .cnpjData[
                                                                                      key +
                                                                                        index
                                                                                    ]
                                                                                      .complement
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ],
                                                                          2
                                                                        ),
                                                                      ],
                                                                      1
                                                                    ),
                                                                  ]),
                                                                ],
                                                                1
                                                              )
                                                            : _vm._e(),
                                                          _c(
                                                            "el-button",
                                                            {
                                                              staticStyle: {
                                                                padding:
                                                                  "4px 5px",
                                                                float: "right",
                                                              },
                                                              attrs: {
                                                                slot: "reference",
                                                                type: "primary",
                                                                plain: "",
                                                                disabled:
                                                                  _vm.viewType ===
                                                                  1,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.showCnpjInfo(
                                                                      key,
                                                                      index,
                                                                      field.field
                                                                    )
                                                                  },
                                                              },
                                                              slot: "reference",
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "el-icon-search",
                                                                staticStyle: {
                                                                  "font-size":
                                                                    "22px",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                2
                                              ),
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        )
                      : _vm._e(),
                    _vm.viewType !== 1
                      ? _c(
                          "el-button",
                          {
                            attrs: { size: "small", type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.addForm(key)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("orderCenterCont.add")))]
                        )
                      : _vm._e(),
                  ],
                  2
                )
              }),
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticStyle: {
          "text-align": "right",
          padding: "20px",
          "border-top": "1px solid #ccc",
        },
      },
      [
        _vm.viewType !== 1
          ? _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.onStoredDetailForm()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("collectionCenter.Stored")))]
            )
          : _vm._e(),
        _vm.viewType !== 1
          ? _c(
              "el-button",
              {
                attrs: { size: "small", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.onSubmitDetailForm()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("collectionCenter.submit")))]
            )
          : _vm._e(),
        _c(
          "el-button",
          {
            attrs: { size: "small", plain: "" },
            on: {
              click: function ($event) {
                return _vm.onCloseDetailWindow(false)
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("collectionCenter.cancel")))]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }